import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Demo from './views/Demo.vue'
import LoginView from '@/views/LoginView.vue'
import RegisterView from '@/views/RegisterView.vue'
import MainView from '@/views/MainView.vue'
import store from './store'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/main/dashboard')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}


export default new Router({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
      // component: MainView
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },

    {
      path: '/demo',
      name: 'demo',
      component: Demo
    },

    {
      path: '/login',
      name: 'login',
      component: LoginView,
      beforeEnter: ifNotAuthenticated,
    },

    {
      path: '/register',
      name: 'register',
      component: RegisterView,
      beforeEnter: ifNotAuthenticated,
    },

    {
      path: '/main',
      // path: '/user/:id',
      // name: 'user',
      component: MainView,
      beforeEnter: ifAuthenticated,
      children: [
        // {
        //   path: '/',
        //   name: 'main',
        //   component: () => import('./views/Main.vue')
        // },
        {
          path: 'activity',
          name: 'activity',
          component: () => import('./views/main/ActivityView.vue')
        },
        {
          path: 'calendar',
          name: 'calendar',
          component: () => import('./views/main/CalendarView.vue')
        },
        {
          path: 'contact',
          name: 'contact',
          component: () => import('./views/main/ContactView.vue')
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: () => import('./views/main/DashboardView.vue')
        },
        {
          path: 'profile',
          name: 'profile',
          component: () => import('./views/main/ProfileView.vue')
        },
        {
          path: 'topten',
          name: 'topten',
          component: () => import('./views/main/TopTenView.vue')
        },
        {
          path: 'purchase',
          name: 'purchase',
          component: () => import('./views/main/PurchaseView.vue')
        },
        {
          path: 'googlecontact',
          name: 'googlecontact',
          component: () => import('./views/main/GoogleContactView.vue')
        },
      ]
    },
    {
      path: '*',
      name: 'notfound',
      component: () => import('./views/NotFoundComponent.vue')
    },
  ]
})
